module.exports = __webpack_public_path__ + "img/banner_online_JP.2e879708.png";